import type { MarkArrivedResponse } from '@/types';

export async function markAsArrived(orderId: number): Promise<MarkArrivedResponse> {
	const response = await fetch('/admin/markarrived', {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: `id=${encodeURIComponent(orderId)}`,
	});

	if (!response.ok) {
		throw new Error(`markAsArrived failed: ${response.status}`);
	}

	const text = await response.text();
	const xml = new DOMParser().parseFromString(text, 'text/xml');
	const status = xml.querySelector('status')?.textContent;

	return { status: status === 'OK' ? 'OK' : 'ERROR' };
}
